<div *ngIf="show"
	class="d-inline-block iconBackground"
	[ngbTooltip]="tooltipTpl"
	[container]="'body'"
	[openDelay]="300"
>
	<!-- pointer events are disabled in order to suppress hover effect -->
	<app-svg
		class="pe-none"
		[size]="svgSizeEnum.SMALL"
		[stateArray]="svgStateArray"
		[type]="svgTypeEnum.AUTHORITIES_BADGE"
	></app-svg>
</div>


<!-- ############################## TEMPLATES ############################## -->
<ng-template #tooltipTpl>
	<!-- shown on ELSTER-required fields only -->
	<div
		*ngIf="indicatesElsterRequiredFormField"
		class="formElsterRequiredTooltip hyphens-none mb-1"
	>
		<div class="fw-semibold">
			{{ getI18nString( false, 'shared.elster.fieldIndicatorTooltip.requiredFormFieldMessage') }}
		</div>
	</div>

	<!-- default content -->
	<div>{{ getI18nString( false, 'shared.elster.fieldIndicatorTooltip.defaultMessage') }}</div>
</ng-template>
